import { fetchBlobData } from '../Api';

export const gerarRelatorioVendasPdf = (filtros) =>
    fetchBlobData('/Relatorios/Vendas/Pdf', filtros);

export const gerarRelatorioVendasExcel = (filtros) =>
    fetchBlobData('/Relatorios/Vendas/Excel', filtros);

export const gerarRelatorioContasReceberPdf = (filtros) =>
    fetchBlobData('/Relatorios/ContasReceber/Pdf', filtros);

export const gerarRelatorioContasReceberExcel = (filtros) =>
    fetchBlobData('/Relatorios/ContasReceber/Excel', filtros);
